export const FILTER_PERIOD = 'period';
export const FILTER_STATUSES = 'statusIds';
export const FILTER_TYPES = 'targetingActivityTypeIds';
export const FILTER_ACTIVITY_TYPE = 'activityTypeIds';
export const FILTER_AFFILIATES = 'affiliateIds';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_COST_MODELS = 'costModelTypeIds';
export const FILTER_COUNTRIES = 'countryIds';
export const FILTER_FRAUD_PROTECTIONS = 'fraudProtectionTypeIds';
export const FILTER_LABELS = 'labelIds';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_OWNERS = 'ownerIds';
export const FILTER_PARTNER_CAMPAIGNS = 'partnerCampaignFilterId';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_PROMO_CODES = 'promoCodeFilterId';
export const FILTER_LOCALES = 'localeIds';
export const FILTER_APPLY_FILTERS = 'applyFilters';
export const FILTER_CPE_EVENTS = 'costModelSubTypeIds';

export const FILTER_DEPENDENCIES = {
  [FILTER_PLATFORMS]: [FILTER_NETWORKS],
  [FILTER_AFFILIATES]: [FILTER_APPLICATIONS],
  [FILTER_NETWORKS]: [FILTER_APPLICATIONS],
  [FILTER_FRAUD_PROTECTIONS]: [FILTER_NETWORKS],
  [FILTER_CPE_EVENTS]: [FILTER_COST_MODELS],
};

export const ACTION_EDIT = 'edit';
export const ACTION_DUPLICATE = 'duplicate';
export const ACTION_ARCHIVE = 'archive';
export const ACTION_ACTIVATE = 'activate';
export const ACTION_GENERATE_LINKS = 'generateLinks';
export const ACTION_COPY_CAMPAIGN_URL = 'copyCampaignURL';
export const ACTION_MOVE_TO_ANOTHER_AFFILIATE = 'moveToAnotherAffiliate';

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_PARENT_CAMPAIGN = 'parentCampaign';
export const COLUMN_CAMPAIGNS = 'campaigns';
export const COLUMN_STATUS = 'status';
export const COLUMN_AFFILIATE = 'affiliate';
export const COLUMN_COST_MODELS_TYPES = 'costModelTypes';
export const COLUMN_COST_MODELS = 'costModels';
export const COLUMN_HAS_REWARDS = 'hasRewards';
export const COLUMN_HAS_COST_MODELS = 'hasCostModels';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_NETWORK = 'network';
export const COLUMN_PLATFORM = 'platform';
export const COLUMN_COUNTRY = 'country';
export const COLUMN_PROMO_CODE = 'promoCode';
export const COLUMN_EXPIRATION_DATE = 'expirationDate';

export const COLUMN_ACTIVITY_TYPE = 'activityType';
export const COLUMN_TYPE = 'targetingActivityType';
export const COLUMN_FRAUD_PROTECTIONS = 'fraudProtections';
export const COLUMN_LABELS = 'labels';
export const COLUMN_CURRENT_OWNER = 'currentOwner';
export const COLUMN_UPDATED_DATE = 'updatedDate';
export const COLUMN_LAST_UPDATED = 'lastUpdated';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED = 'created';
export const COLUMN_CREATED_DATE = 'createdDate';
export const COLUMN_CPE_EVENTS = 'costModelEvents';

export const COLUMN_LINK_TYPE = 'linkType';
export const COLUMN_LINK_EXPIRATION_DATE = 'linkExpirationDate';
export const COLUMN_DEEP_LINK_REWARD_PACKAGE = 'deepLinkRewardPackage';
export const COLUMN_DEEP_LINK_MULTIPLE_REDEMPTIONS =
  'isDeepLinkMultipleRedemption';
export const COLUMN_DEEP_LINK_MAX_REDEMPTIONS = 'deepLinkMaxRedemptions';

export const STATUS_ACTIVE = 0;
export const STATUS_INACTIVE = 1;

export const TEMPLATE_NEW_CAMPAIGN = 'newCampaign';
export const TEMPLATE_UPDATE_CAMPAIGN = 'updatingCampaign';
export const TEMPLATE_UPDATE_INFLUENCER_CAMPAIGN =
  'updatingInfluencerCampaigns';
